import React from 'react';
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useSelector } from "react-redux";
import { siteKeySelector } from "../../store/hcaptcha";

export default function InputHCaptcha({ onChange, value, ...props }) {
  const siteKey = useSelector(siteKeySelector);

  const fireChange = newValue => {
    if (newValue === value)
      return;
    if (typeof onChange === 'function')
      onChange(newValue);
  };

  return (
    <HCaptcha
      sitekey={siteKey}
      onVerify={(token) => fireChange(token)}
      {...props}
    />
  );
}
